import { render, staticRenderFns } from "./surchargedFileHistory.vue?vue&type=template&id=b2e577fc"
import script from "./surchargedFileHistory.vue?vue&type=script&lang=js"
export * from "./surchargedFileHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e577fc')) {
      api.createRecord('b2e577fc', component.options)
    } else {
      api.reload('b2e577fc', component.options)
    }
    module.hot.accept("./surchargedFileHistory.vue?vue&type=template&id=b2e577fc", function () {
      api.rerender('b2e577fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/shippingCharges/components/surchargedFileHistory.vue"
export default component.exports